import { classes } from 'html-classes';
import React from 'react';

import styles from './Radio.module.scss';

export interface RadioProps {
  label: string | React.ReactNode;
  value: string | number;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  disabled?: boolean;
  name?: string;
}

export const Radio: React.FC<RadioProps> = ({
  label,
  value,
  checked,
  onChange,
  className,
  disabled = false,
  name,
}) => {
  return (
    <label
      className={classes([
        styles.radio,
        className,
        disabled && styles.disabled,
      ])}
    >
      <input
        type="radio"
        checked={checked}
        value={value}
        className={styles.input}
        onChange={onChange}
        disabled={disabled}
        name={name}
      />
      <span className={styles.mark} />
      <span className={styles.label}>{label}</span>
    </label>
  );
};
